import React, { useState, useEffect } from 'react';
import { Box, Stack, Button, TextField, Badge, Tooltip, FormControlLabel, Checkbox, Typography } from '@mui/material'
import { DialogWindow } from  './general';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import dayjs from 'dayjs'
import  StaticDateTimePicker  from './custom/dateTimePicker.js'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { getItemsOccupancyForExtend } from '../services/products.js'
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeUserAction } from '../actions/profile.js';

const classes = {
    indProductCont: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
    },
    indProductItem :{
        margin: '0px 10px'
    },
    dateCont: {
        display: 'flex',
        marginBottom: 10
    },
    dateInd: {
        marginRight: 20
    },
}


const DateBar = ({fromDate, setFromDate, toDate, setToDate, bookingDetails, occupancyData}) => {
  
    return (
        <Stack direction="column">
                <Stack direction="column" sx={{mb: '18px'}}>
                    <Typography sx={{fontSize: '0.75rem', color: 'black'}}>From Date</Typography>
                    <Typography sx={{mt: '12px'}}>{dayjs(fromDate).format('Do MMM YY (ddd) HH:mm A')}</Typography>
                </Stack>
            
                <Stack direction="column">
                    <Typography sx={{fontSize: '0.75rem', color: 'black'}}>To Date</Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <StaticDateTimePicker
                            label="To Date"
                            value={toDate}
                            ampm={false}
                            occupancyData={occupancyData}
                            maxDate={dayjs(bookingDetails?.to).add(7, 'day')}
                            minDate={dayjs(bookingDetails?.to).add(1, 'day')}
                            products={bookingDetails.products}
                            format='DD/MM/YYYY hh:mm A'
                            onChange={(newValue) => {
                                setToDate(newValue);
                            }}
                        />
                    </LocalizationProvider>
                </Stack>
        </Stack>
            
    )
}

const IndProduct = ({product, index}) => {
  return (
    
      <div style={classes.indProductCont}>
        <div style={classes.indProductItem}># {index+1}</div>
        <div style={classes.indProductItem}><img height={50} src={product?.image?.thumb??''}/></div>
        <Badge badgeContent={product.count} color="primary">
          <div style={classes.indProductItem}>{product.name}</div>      
        </Badge>
      </div>
    
  )
}

const BillableDates = ({fromDate, toDate, setBillableDates, billableDates, bookingDetails}) => {
  const {billableDates: oldBillableDates, to} = bookingDetails
  let dayNameArray = []
  const handleCheckBoxClick = (date) => {
    return (e) => {
      if (e.target.checked) {
        setBillableDates([...billableDates, date])
      } else {
        const _billableDates = [...billableDates]
        const index = _billableDates.indexOf(date)
        if (index > -1) {
          _billableDates.splice(index, 1)
          setBillableDates(_billableDates)
        }
      }
    }
  }
  for (let currentDate = dayjs(fromDate); currentDate.isSameOrBefore(toDate, "day"); currentDate = currentDate.add(1, 'day')) {
    dayNameArray.push(
      <Tooltip key={currentDate.format('ddd')}  title={currentDate.format("DD MMM")}>
        <FormControlLabel
          control={
              <Checkbox
                disabled={currentDate.isSameOrBefore(dayjs(to), 'day')}
                onChange={handleCheckBoxClick(currentDate.format("DD-MM-YYYY"))}
                checked={billableDates.indexOf(currentDate.format("DD-MM-YYYY")) > -1 || oldBillableDates.indexOf(currentDate.format("DD-MM-YYYY")) > -1}/>}
                label={currentDate.format('ddd')              
            } 
        />
      </Tooltip>)
  }
  return (
    <Stack direction="column" spacing={8} sx={{mb: 2}}>
        <Stack direction="column" alignItems="flex-start">
            <Stack direction="row" alignItems="center">
                <Typography sx={{mr: 1}}>Select Billable Date : </Typography>
                    {dayNameArray}
                </Stack>
            <Typography sx={{ml: 1}} variant="caption" display="block" gutterBottom component="div">{billableDates.length + oldBillableDates.length} days </Typography>
        </Stack>
    </Stack>
  )
}

const Actions = ({billableDates, handleExtend}) => {  
    return (
        <Stack direction="row" spacing={2}>
            <Button disabled={billableDates?.length === 0} sx={{flex: '1 0 auto', mb: 1, alignItems: 'flex-start'}} key={`action2`} variant="contained" onClick={handleExtend} endIcon={<OpenInFullIcon />}>Extend </Button>
        </Stack>

    )
}

const Body = ({bookingDetails, fromDate, toDate, setFromDate, setToDate, billableDates, setBillableDates, discount, setDiscount, total, occupancyData}) => {
    if (bookingDetails && total) {
        return (
            <Box>
                <Stack direction="row">
                    <Box sx={{width: '40%'}}>
                        <DateBar fromDate={fromDate} toDate={toDate} setFromDate={setFromDate} setToDate={setToDate} bookingDetails={bookingDetails} occupancyData={occupancyData}/>
                        <BillableDates fromDate={fromDate} toDate={toDate} billableDates={billableDates} setBillableDates={setBillableDates} bookingDetails={bookingDetails}/>
                    </Box>
                    <Box sx={{width: '40%'}}>
                        {bookingDetails.products.map((product, index)=><IndProduct index={index} key={`product-${index}`} product={product}/>)}
                    </Box>
                    <Stack spacing={2} sx={{width: '20%'}}>
                        <TextField size="small"
                          value={bookingDetails.advance} 
                          disabled label="Advance"
                        />
                        <TextField
                          size="small"
                          value={discount}
                          onChange={(e)=>setDiscount(e.target?.value ? parseInt(e.target?.value.replace(/[^0-9.]/g, '')) : 0) }
                          label="Discount"
                          helperText={discount < bookingDetails.discount ? `You've reduced from old discount of  ₹ ${bookingDetails.discount}` : `Old Discount : ₹ ${bookingDetails.discount}`}
                          FormHelperTextProps = {{
                            sx: discount < bookingDetails.discount ? {color: '#ff8503' } : {}
                          }}
                        />
                        <TextField
                          size="small"
                          value={total + discount}
                          disabled
                          label="Gross Amount"
                          helperText={`Old Gross Amount : ₹ ${bookingDetails.amount + bookingDetails.discount}`}
                        />
                        <TextField
                          size="small"
                          value={total}
                          disabled
                          label="Nett Amount"
                          helperText={`Old Nett Amount: ₹ ${bookingDetails.amount}`}
                        />
                        <TextField
                          size="small"
                          value={Math.max(0, total-discount-bookingDetails.advance)}
                          helperText={`Old Balance: ₹ ${bookingDetails.amount - bookingDetails.advance}`}
                          disabled label="Balance"
                        />
                    </Stack>
                </Stack>
            </Box>
        )
    }
  return null;
}

export default function ExtendBooking({open, setOpen, selectedBooking, bookings, doExtend}) {

    const [fromDate, setFromDate] = useState()
    const [toDate, setToDate] = useState()
    const [bookingDetails, setBookingDetails] = useState()
    const [billableDates, setBillableDates] = useState([])
    const [discount, setDiscount] = useState(0)
    const [total, setTotal] = useState()
    const [occupancyData, setOccupancydata] = useState();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const getItemOccupancyData = async(date, items) => {
      try {
        const data = await getItemsOccupancyForExtend(date, items);
        setOccupancydata(data);
      } catch (e) {
        if (e.status === 401) {
            dispatch(removeUserAction())
            navigate('/');
        }
      }
    }

    useEffect(()=>{
        if (selectedBooking) {
            const book = bookings.find(book=>book._id === selectedBooking)
            setBookingDetails(book)
            setFromDate(dayjs(book.from))
            setToDate(dayjs(book.to).add(1, 'day'))
            getItemOccupancyData(dayjs(book.to).add(1, 'day').format("YYYY-MM-DD"), book.items.map(item => item.item))
        }
    }, [selectedBooking])

    useEffect(()=>{
        if (fromDate && toDate) {
            const currentFromDate = dayjs(fromDate);
            if (currentFromDate.isSame(dayjs(toDate), "day")) {            
              setBillableDates([currentFromDate.format("DD-MM-YYYY")])
            }
        }
    }, [fromDate, toDate])

      useEffect(()=>{
        if (bookingDetails) {
          const _total = bookingDetails.products.reduce((acc, item)=>{return acc+(parseInt(item.rent, 10)*(billableDates.length + bookingDetails.billableDates.length)*item.count)}, 0)
          setDiscount(bookingDetails.discount)
          setTotal(_total)
        }
      },[bookingDetails, billableDates])
    
    const handleExtend = () => {
        doExtend(toDate, discount, total, billableDates)
    }

    return (
        <DialogWindow
            title={'Extend Booking'}
            Body={<Body
                    bookingDetails={bookingDetails}
                    fromDate={fromDate}
                    toDate={toDate}
                    setToDate={setToDate}
                    setFromDate={setFromDate}
                    billableDates={billableDates}
                    setBillableDates={setBillableDates}
                    discount={discount}
                    setDiscount={setDiscount}
                    total={total}
                    occupancyData={occupancyData}
                />}
            Actions={<Actions billableDates={billableDates} handleExtend={handleExtend}/>}
            open={open}
            setOpen={setOpen} 
            maxWidth={'lg'}
        />
    )
}